import { useState, useEffect, useReducer } from 'react'
import { Switch, Route, useParams } from 'react-router-dom'

import { Flex } from '../../../../primitives'

import Table from './Table'
import Form from './Form'

import { tableReducer, tableInitialState } from './state'

const MODULE_PATH = '/operations/:zone+/inventory/fertilizer/calibration'

function FertilizerInventoryCalibration({ backPath, fertilizerInventoryId }) {
  const params = useParams()

  const [state, dispatchState] = useReducer(tableReducer, tableInitialState)

  const [modulePath, setModulePath] = useState(MODULE_PATH)

  useEffect(() => {
    if (params?.zone) {
      setModulePath(MODULE_PATH.replace(':zone+', params.zone))
    }
  }, [params?.zone])

  return (
    <Flex axisGap={400} direction='column'>
      <Switch>
        <Route path={[`${MODULE_PATH}/create`]} exact={true}>
          <Form
            state={state}
            dispatchState={dispatchState}
            modulePath={modulePath}
            fertilizerInventoryId={fertilizerInventoryId}
          />
        </Route>
        <Route path={MODULE_PATH} exact={true}>
          <Table
            state={state}
            dispatchState={dispatchState}
            modulePath={modulePath}
            backPath={backPath}
            fertilizerInventoryId={fertilizerInventoryId}
          />
        </Route>
      </Switch>
    </Flex>
  )
}

export default FertilizerInventoryCalibration
